export default {
  path: '/account-deletion',
  name: 'AccountDeletion',
  component: () => import(/* webpackChunkName: "base/login" */ '../views/AccountDeletionView.vue'),
  meta: {
    layout: 'centered',
    exclude: true,
    requiresAuth: false,
    needsPermission: false
  }
}
